import api from 'service/api'

const dponetAPI = api.create('dponet')

const getQuestions = async ({ questionnaireId, ...params }) => {
  return await dponetAPI.get(
    `/questionnaires/${questionnaireId}/quiz_question_templates`,
    {
      params,
    },
  )
}

const diagnosticQuestions = async ({
  supplierId = '',
  quizTemplateId = '',
}) => {
  return await dponetAPI.get(
    `/company_suppliers/${supplierId}/supplier_questionnaires/${quizTemplateId}/diagnostic`,
  )
}

const supplierQuestions = async ({
  supplierId = '',
  quizTemplateId,
  ...params
}) => {
  return await dponetAPI.get(
    `/company_suppliers/${supplierId}/supplier_questionnaires/${quizTemplateId}/supplier`,
    { params },
  )
}

const getAlternatives = async ({ questionnaireId, questionId, ...params }) => {
  return await dponetAPI.get(
    `/questionnaires/${questionnaireId}/quiz_question_templates/${questionId}/alternatives`,
    { params },
  )
}

const createAnswer = async ({
  questionnaireId,
  questionId,
  alternativeId,
  ...data
}) => {
  const endpoint = `/questionnaires/${questionnaireId}/quiz_question_templates/${questionId}/alternatives/${alternativeId}/answers`

  // Se houver evidências (arquivos), use postForm para enviar FormData
  if (data?.evidence) {
    return await dponetAPI.postForm(endpoint, { answer: data })
  }

  return await dponetAPI.post(endpoint, { answer: data })
}

const updateAnswer = async ({
  questionnaireId,
  questionId,
  alternativeId,
  answerId,
  ...data
}) => {
  const endpoint = `/questionnaires/${questionnaireId}/quiz_question_templates/${questionId}/alternatives/${alternativeId}/answers/${answerId}`

  if (data?.evidence) {
    return await dponetAPI.putForm(endpoint, { answer: data })
  }

  return await dponetAPI.put(endpoint, { answer: data })
}

export default {
  createAnswer,
  diagnosticQuestions,
  getAlternatives,
  getQuestions,
  supplierQuestions,
  updateAnswer,
}
